import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/Home.vue'
import HeroTest from './pages/HeroTest.vue'

import TestStart from './components/start.vue'
import testResult from './components/testResult.vue'

// questions
import One from './components/questions/one.vue'
import Two from './components/questions/two.vue'
import Three from './components/questions/three.vue'
import Four from './components/questions/four.vue'
import Five from './components/questions/five.vue'
import Six from './components/questions/six.vue'

// games
import Puzzle from './components/games/puzzle.vue'
import Tower from './components/games/tower.vue'
import Jump from './components/games/jump.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/teachers',
      name: 'hero_test_teacher',
      component: HeroTest
    },
    {
      path: '/students',
      name: 'hero_test_students',
      redirect: '/',
    },
    {
      path: '/',
      name: 'hero_test',
      component: HeroTest,
      redirect: '/start',
      children: [
        {
          path: 'start',
          component: TestStart 
        },
        {
          path: 'one',
          name: 'first_question',
          component: One
        },
        {
          path: 'two',
          component: Two 
        },
        {
          path: 'puzzle',
          component: Puzzle
        },
        {
          path: 'three',
          component: Three 
        },
        {
          path: 'four',
          component: Four 
        },
        {
          path: 'tower',
          component: Tower
        },
        {
          path: 'five',
          component: Five 
        },
        {
          path: 'six',
          component: Six 
        },
        {
          path: 'jump',
          component: Jump
        },
        {
          path: 'result',
          component: testResult 
        }
      ]
    }
  ]
})
